export const PaymentOptions = {
  Advance: {
    value: 'Advance',
    label: 'Advance'
  },
  Normal: {
    value: 'Normal',
    label: 'Buy now'
  }
};

export const VoucherDetailTabs = [
  {
    'value': 'Summary',
    'label': 'Summary'
  },
  {
    'value': 'Redemptions',
    'label': 'Redemptions'
  }
];

export const ActivationStatus = {
    Expired: 'Expired',
    RedeemPending: 'Active',
    Redeemed: 'Redeemed',
    Failed: 'Failed'
};

export const VoucherTransactionType = {
  Advance: 'ADVANCE',
  Repayment: 'REPAYMENT'
};

export const VoucherTransactionStatus = {
  Success: 'Success',
  Failure: 'Failure'
};

export const VoucherShareMessageVariables = {
  value: '{VOUCHER_VALUE}',
  description: '{VOUCHER_DESCRIPTION}',
  code: '{VOUCHER_CODE}',
  expiryDate: '{VOUCHER_EXPIRY_DATE}'
};

export const VoucherAdvanceMessageVariables = {
  value: '{VOUCHER_VALUE}',
  voucherPaymentDate: '{VOUCHER_PAYMENT_DATE}'
};

export const PaymentSuccessMessageVariables = {
  value: '{VOUCHER_VALUE}'
};

export const VoucherAdvanceRedemptionComments = {
  created: 'Reward Created',
  voucherCreated: 'Voucher Created',
  final: 'Final Redemption'
};